import Util from '../../module/libs/util';

import effectManager from '../../module/effect';

let effect = new effectManager();
let util = new Util();

export default class tabManager {
    constructor() {

        this.pageID;

        this.$container;
        this.$nav;
        this.$body;
        this.$target;
        this.$spNav;
        this.$select;

        this.$exLink;

        this.$footer;
        this.$footerBtn;
        this.$footerBtnText;
        this.$footerBtnBg;

        this.hiddenClass;
        this.$hiddenImage;

        this.footerBtnTextArray = ["PRODUCT","PROCESS"];

        this.prevSelect = 0;
        this.prevCurrent = "";
        this.current = "js__target1";

        this.resizeFlg = false;

        this.anchor = {
            "business" : {
                "product":1,
                "process":2,
            }
        }


     }
    init(pageID){

        this.pageID=pageID;

        this.$container = document.getElementById("l-lowlayer-body-pagenavi");
        this.$nav = this.$container.querySelectorAll("li");
        this.$body = document.getElementById("l-lowlayer-body-contents");
        this.$target = this.$body.querySelectorAll(".l-tab-content");
        this.$spNav = document.querySelector("#l-lowlayer-body-select select");
        this.$spNavText = document.getElementById("l-lowlayer-body-select-text");
        this.$select;


        if(this.pageID=="business"){
            this.$footer = document.getElementById("l-footer");
            this.$footerBtn = document.getElementsByClassName("p-business-link");
            this.$footerBtnText = this.$footerBtn[0].getElementsByClassName("title");
            this.$footerBtnBg = document.getElementsByClassName("p-business-link__bg");

            this.$exLink = document.getElementsByClassName("js__tab-link-ex");

        }

        effect.show(document.querySelectorAll(".js__tc-show"),"set");


        let _hash = util.getHash(),
            _hashPos = _hash.indexOf("?");

        /* パラメータが含まれていたら取り除く */
        _hash = _hashPos>=0?_hash.substring(0, _hashPos):_hash;

        /* ハッシュタグ指定されていたらタブを切り替え */
        if(_hash){
            this.current = "js__target"+this.anchor[pageID][_hash];
            this.$select = document.getElementById(this.current);
            setTimeout(()=>{
                this.motion(this.$nav[this.anchor[pageID][_hash]],this.$nav[this.anchor[pageID][_hash]].getAttribute("data-target"));
            },1e3);
        }else{
            this.getSelectConttainer();
            this.$select = document.getElementById(this.current);
            setTimeout(()=>{
                this.motion(this.$nav[0],this.$nav[0].getAttribute("data-target"));
            },1e3);
        }

        /* パラメータ指定されていたら指定位置までスクロール移動 */
        let _param = util.getParam("select");

        if(_param){
            // TweenLite.to(window, 0.3,{scrollTo:{y:"#p-product-"+_param,autoKill:false}});
            setTimeout(()=>{
                let _posi = document.getElementById("p-product-"+_param).getBoundingClientRect().top + window.pageYOffset;
                _posi = _posi - document.getElementById("l-header").clientHeight - 20;
                TweenLite.to(window, 0.3,{scrollTo:{y:_posi,autoKill:false}});
            },1e3);
        }



        //effect.show(this.$select.querySelectorAll(".js__tc-show"),"show");

        // ページ上部のタブ
        for(let i=0; i<this.$nav.length; i++){
            this.$nav[i].addEventListener("click",(e)=> {

                this.motion(e.target,e.target.getAttribute("data-target"),"select")

            });
        }

        // select 変更したとき
        this.$spNav.addEventListener("change",(e)=> {
            this.motion(this.$nav[Number(e.target.value)-1],e.target.value,"select");
            if(this.$spNavText){
                this.change(Number(e.target.value)-1);
            }
        });

        //フッターにあるでかバナー押したとき
        if(this.pageID=="business"){
            this.$footerBtn[0].addEventListener("click",(e)=>{
                e.stopPropagation();
                TweenLite.to(window, 0.3,{scrollTo:{y:"#l-lowlayer-body",autoKill:false},
                    onComplete: () => {
                        this.motion(this.$nav[Number(e.target.getAttribute("data-next")) - 1], e.target.getAttribute("data-next"), "select");
                    }
                });
            });

            for(let i=0; i<this.$exLink.length; i++){
                this.$exLink[i].addEventListener("click",(e)=>{
                    e.stopPropagation();
                    this.motion(this.$nav[Number(e.target.getAttribute("data-href"))-1],e.target.getAttribute("data-href"),"select");
                    TweenLite.to(window, 0.3,{scrollTo:{y:"#l-lowlayer-body",autoKill:false}});
                });
            }
        }



    }

    change(Index){

        for (var i = 0; i < this.$spNavText.children.length; i++){
            if(i === Index){
                TweenMax.set(this.$spNavText.children[i],{
                    "display" : "block"
                });
            }else{
                TweenMax.set(this.$spNavText.children[i],{
                    "display" : "none"
                });
            }
        }

    }

    motion($target,select,type){
        if(select == this.prevSelect) return;
        if(type=="select") this.prevCurrent = this.current;


        for(let i=0; i<this.$nav.length; i++){
            this.$nav[i].classList.remove("is-current");
            this.$target[i].classList.remove("is-current");
        }
        $target.classList.add("is-current");

        // $spNavText表示切り替え
        if(this.$spNavText){
            this.change(select - 1);
        }

        this.current = "js__target" + select;
        this.$spNav.value = select;
        let _$prev;
        if(type=="select") _$prev = document.getElementById(this.prevCurrent);
        this.$select = document.getElementById(this.current);

        this.$select.classList.add("is-current");

        if(type=="select") effect.show(_$prev.querySelectorAll(".js__tc-show"),"out");
        setTimeout(()=> {
            if(type=="select") _$prev.style.display = "none";
            this.$select.style.display = "";
            effect.show(this.$select.querySelectorAll(".js__tc-show"),"show");
            this.resize();
            this.resizeFlg = true;
        },5e2);


        //フッターのでかバナー更新
        if(this.pageID=="business"){
            if(select==3){
                // 3つめの場合表示を消す
                TweenMax.to([this.$footerBtn,this.$footerBtnBg],0.4,{
                    "display" : "none",
                    onComplete:()=>{
                        this.$footer.classList.remove("type-orange")
                    }
                });

            }else{
                if(!this.$footer.classList.contains("type-orange")) TweenMax.to([this.$footerBtn,this.$footerBtnBg],0.4,{
                    "display" : "block",
                    onComplete:()=>{
                        this.$footer.classList.add("type-orange")
                    }
                });
                this.$footerBtn[0].setAttribute("data-next",Number(select)+1);
                this.$footerBtnText[0].textContent = this.footerBtnTextArray[select-1];
            }
        }

        // classを指定して背景画像を非表示
        this.hiddenClass = "js__business_" + select;
        this.$hiddenImage = document.getElementsByClassName(this.hiddenClass);

        if(!this.$hiddenImage[0]) return;
        for (let i = 0; i < this.$hiddenImage.length; i++) {
            this.$hiddenImage[i].style.display = "none";
        }

    }

    getSelectConttainer(){

        for(let i= 0; this.$target.length>i; i++){
            if(this.$target[i].classList.contains("is-current")){
                this.$select = this.$target[i];
            }
        }

    }
    resize(){

        TweenMax.set(this.$body,{ height:this.$select.clientHeight });

    }


}